import { Directive, input } from '@angular/core';

/**
 * Native port of the v1 `ftDisabled` directive (account-v1/src/components/common/
 * disabled/disabled.js). `[class.disabled]` alone doesn't stop clicks — there is no
 * `.launch-preview.disabled` CSS rule — so, like v1, a truthy expression must
 * physically block the click via inline `pointer-events: none` (+ the `disabled`
 * attribute v1 set). The launch-preview EMAIL-SAMPLE senders have no handler-level
 * guard: without this, a "disabled" click still sends a real sample email.
 */
@Directive({
  selector: '[ftDisabled]',
  host: {
    '[style.pointer-events]': "ftDisabled() ? 'none' : null",
    '[attr.disabled]': "ftDisabled() ? 'disabled' : null",
  },
})
export class FtDisabledDirective {
  readonly ftDisabled = input.required<boolean>();
}
